var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var _a;
import * as actions from 'app/actions/transport';
import http from 'app/services/http';
import { AUTOCOLON_ADD_ITEM, AUTOCOLON_DELETE_ITEM, AUTOCOLON_SEARCH_VALUE, AUTOCOLON_SELECT_ITEM, AUTOCOLON_SET_ITEM, AUTOCOLONS_SET_ITEMS, DIVISION_ADD_ITEM, DIVISION_DELETE_ITEM, DIVISION_SET_ITEM, DIVISION_SET_ITEMS, GEOFENSE_SET_SEARCH_VALUE } from 'app/utils/constants';
import { batch } from 'react-redux';
const defaultSort = config.transportColumns[0];
const initialState = {
    items: [],
    checkedItems: [],
    transportColumnCheckedItems: (_a = JSON.parse(localStorage.getItem('transportPageColumnCheckedItems'))) !== null && _a !== void 0 ? _a : config.transportColumns.filter((column) => !column.hidden).map((column) => column.name),
    canGenerationItems: [],
    selectedItem: null,
    sortSelectedItem: { name: defaultSort.name, order: defaultSort.order },
    searchValue: '',
    typeItems: [],
    modelItems: [],
    groupItems: [],
    groupTypeItems: [],
    groupSelectedItem: null,
    groupSearchValue: '',
    checkListSelectedItem: null,
    inspectionSelectedItem: null,
    autocolonItems: [],
    divisionItems: [],
    autocolonSelectedItem: null,
    autocolonSearchValue: '',
    geofenceSearchValue: '',
};
export const transportReducer = (state = initialState, action) => {
    var _a;
    switch (action.type) {
        case GEOFENSE_SET_SEARCH_VALUE: {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { geofenceSearchValue: value });
        }
        case AUTOCOLON_DELETE_ITEM: {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { autocolonItems: state.autocolonItems.filter((item) => item.id !== id) });
        }
        case DIVISION_DELETE_ITEM: {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { divisionItems: state.divisionItems.filter((item) => item.id !== id) });
        }
        case AUTOCOLON_ADD_ITEM: {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { autocolonItems: [...state.autocolonItems, data] });
        }
        case DIVISION_ADD_ITEM: {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { divisionItems: [...state.divisionItems, data] });
        }
        case AUTOCOLON_SET_ITEM: {
            const { item } = action.payload;
            let index = state.autocolonItems.findIndex((autocolonItem) => autocolonItem.id === item.id);
            const newAutocolonItems = [...state.autocolonItems];
            if (index !== -1) {
                newAutocolonItems.splice(index, 1, item);
            }
            else {
                newAutocolonItems.push(item);
            }
            return Object.assign(Object.assign({}, state), { autocolonItems: newAutocolonItems });
        }
        case DIVISION_SET_ITEM: {
            const { item } = action.payload;
            let index = state.divisionItems.findIndex((divisionItem) => divisionItem.id === item.id);
            const newDivisionItems = [...state.divisionItems];
            if (index !== -1) {
                newDivisionItems.splice(index, 1, item);
            }
            else {
                newDivisionItems.push(item);
            }
            return Object.assign(Object.assign({}, state), { divisionItems: newDivisionItems });
        }
        case AUTOCOLON_SELECT_ITEM: {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { autocolonSelectedItem: value });
        }
        case AUTOCOLON_SEARCH_VALUE: {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { autocolonSearchValue: value });
        }
        case 'TRANSPORT_SET_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { items: items });
        }
        case 'TRANSPORT_ADD_CHECKED_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { checkedItems: [...state.checkedItems, id] });
        }
        case 'TRANSPORT_DELETE_CHECKED_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { checkedItems: state.checkedItems.filter((checkedId) => checkedId !== id) });
        }
        case 'TRANSPORT_ADD_COLUMN_CHECKED_ITEM': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { transportColumnCheckedItems: [...state.transportColumnCheckedItems, value] });
        }
        case 'TRANSPORT_DELETE_COLUMN_CHECKED_ITEM': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { transportColumnCheckedItems: state.transportColumnCheckedItems.filter((transportColumnCheckedItem) => transportColumnCheckedItem !== value) });
        }
        case 'TRANSPORT_SET_SELECTED_ITEM': {
            const { data } = action.payload;
            if (!data) {
                return Object.assign(Object.assign({}, state), { inspectionSelectedItem: null, selectedItem: null });
            }
            return Object.assign(Object.assign({}, state), { inspectionSelectedItem: null, selectedItem: Object.assign(Object.assign({}, data), { inspections: [] }) });
        }
        case 'TRANSPORT_SET_SELECTED_ITEM_INSPECTION_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { selectedItem: Object.assign(Object.assign({}, state.selectedItem), { inspections: items }) });
        }
        case 'TRANSPORT_SET_INSPECTION_SELECTED_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { inspectionSelectedItem: data });
        }
        case 'TRANSPORT_SET_SEARCH_VALUE': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { searchValue: value });
        }
        case 'TRANSPORT_SET_SORT_SELECTED_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { sortSelectedItem: {
                    name: data.name,
                    order: state.sortSelectedItem.name !== data.name ? data.order : state.sortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                } });
        }
        case 'TRANSPORT_ADD_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { items: [...state.items, data] });
        }
        case 'TRANSPORT_UPDATE_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { items: state.items.map((value) => {
                    if (value.id !== state.selectedItem.id) {
                        return value;
                    }
                    return Object.assign(Object.assign({}, state.selectedItem), data);
                }), selectedItem: Object.assign(Object.assign({}, state.selectedItem), data) });
        }
        case 'TRANSPORT_DELETE_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { items: state.items.filter((item) => item.id !== id), selectedItem: null });
        }
        case 'TRANSPORT_UPDATE_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { items: state.items.map((value) => items.find((item) => item.id === value.id) || value), checkedItems: [] });
        }
        case 'TRANSPORT_TYPE_SET_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { typeItems: items });
        }
        case 'TRANSPORT_MODEL_SET_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { modelItems: items });
        }
        case 'TRANSPORT_GROUP_SET_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: items });
        }
        case 'TRANSPORT_GROUP_SET_SELECTED_ITEM': {
            const { data } = action.payload;
            if (!data) {
                return Object.assign(Object.assign({}, state), { checkListSelectedItem: null, groupSelectedItem: null });
            }
            return Object.assign(Object.assign({}, state), { checkListSelectedItem: null, groupSelectedItem: Object.assign(Object.assign({}, data), { transports: [], checklists: [] }) });
        }
        case 'TRANSPORT_GROUP_SET_SELECTED_ITEM_TRANSPORT_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { transports: items }) });
        }
        case 'TRANSPORT_GROUP_SET_SEARCH_VALUE': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSearchValue: value });
        }
        case 'TRANSPORT_GROUP_ADD_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: [...state.groupItems, data] });
        }
        case 'TRANSPORT_GROUP_UPDATE_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: state.groupItems.map((item) => {
                    if (item.id !== data.id) {
                        return item;
                    }
                    return Object.assign(Object.assign({}, item), data);
                }), groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), data) });
        }
        case 'TRANSPORT_GROUP_DELETE_ITEM': {
            const { id } = action.payload;
            return Object.assign(Object.assign({}, state), { groupItems: state.groupItems.filter((item) => item.id !== id), groupSelectedItem: null });
        }
        case 'TRANSPORT_SET_CAN_GENERATION_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { canGenerationItems: items });
        }
        case 'TRANSPORT_GROUP_SET_TYPE_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { groupTypeItems: items });
        }
        case 'TRANSPORT_GROUP_SET_CHECKLIST_ITEMS': {
            const { items } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { checklists: items }) });
        }
        case 'TRANSPORT_GROUP_SET_CHECKLIST_SELECTED_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { checkListSelectedItem: data });
        }
        case 'TRANSPORT_GROUP_ADD_CHECK_LIST_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { checklists: [data, ...state.groupSelectedItem.checklists] }) });
        }
        case 'TRANSPORT_GROUP_UPDATE_CHECKLIST_ITEM': {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { groupSelectedItem: Object.assign(Object.assign({}, state.groupSelectedItem), { checklists: state.groupSelectedItem.checklists.map((item) => {
                        if (item.id !== data.id) {
                            return item;
                        }
                        return Object.assign(Object.assign({}, item), data);
                    }) }) });
        }
        case AUTOCOLONS_SET_ITEMS: {
            const { data } = action.payload;
            const id = (_a = state === null || state === void 0 ? void 0 : state.autocolonSelectedItem) === null || _a === void 0 ? void 0 : _a.id;
            const item = data.find((autocolon) => autocolon.id === id);
            let autocolonSelectedItem = item && state.autocolonSelectedItem ? item : undefined;
            return Object.assign(Object.assign({}, state), { autocolonItems: data, autocolonSelectedItem });
        }
        case DIVISION_SET_ITEMS: {
            const { data } = action.payload;
            return Object.assign(Object.assign({}, state), { divisionItems: data });
        }
        default:
            return state;
    }
};
export function transportLoad() {
    return function transportLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/transport');
            return dispatch(actions.setItems(data));
        });
    };
}
export function transportCreate(params) {
    return function transportCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/transport', params);
            return dispatch(actions.addItem(data));
        });
    };
}
export function transportBulkCreate(params) {
    return function transportBulkCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/transport/bulk', params);
            data.items.forEach((item) => {
                dispatch(actions.addItem(item));
            });
            return data;
        });
    };
}
export function transportUpdate(id, params) {
    return function transportUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/transport/${id}`, params);
            return dispatch(actions.updateItem(data));
        });
    };
}
export function transportDelete(id) {
    return function transportDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/transport/${id}`);
            return dispatch(actions.deleteItem(id));
        });
    };
}
export function transportDataLoad(id) {
    return function transportDataLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/transport/${id}/inspection`);
            return dispatch(actions.setInspectionItems(data));
        });
    };
}
export function transportTypeLoad() {
    return function transportTypeLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/transport/type');
            return dispatch(actions.setTypeItems(data));
        });
    };
}
export function transportModelLoad() {
    return function transportModelLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/transport/model');
            return dispatch(actions.setModelItems(data));
        });
    };
}
export function transportGroupLoad() {
    return function transportGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/transport/group');
            return dispatch(actions.setGroupItems(data));
        });
    };
}
export function transportGroupDataLoad(id) {
    return function transportGroupDataLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get(`/transport/group/${id}`);
            return batch(() => {
                dispatch(actions.setGroupSelectedItemTransportItems(data.transports));
                dispatch(actions.setGroupCheckListItems(data.checklists));
            });
        });
    };
}
export function transportGroupTransportSend(params) {
    return function transportGroupTransportSendThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/transport/items/send', params);
            return dispatch(actions.updateItems(data));
        });
    };
}
export function transportGroupCreate(params) {
    return function transportCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/transport/group', params);
            return dispatch(actions.addGroupItem(data));
        });
    };
}
export function createDivisionAutocolon(params) {
    return function transportCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { type, name, selectedAutocolons, id_division } = params;
            if (type === 'division') {
                const { data } = yield http.post('/division', { name });
                dispatch(actions.addDivisionItem(data));
                if (selectedAutocolons.length) {
                    for (let autocolon of selectedAutocolons) {
                        const res = yield http.put(`/autocolon/${autocolon.id}`, autocolon);
                        dispatch(actions.setAutocolonItem(res.data));
                    }
                }
                return;
            }
            const { data } = yield http.post('/autocolon', {
                name,
                id_division,
            });
            return dispatch(actions.addAutocolonItem(data));
        });
    };
}
export function updateDivisionAutocolon(params) {
    return function transportCreateThunk(dispatch, getState) {
        return __awaiter(this, void 0, void 0, function* () {
            const { type, name, selectedAutocolons, id_division, unselectedAutocolons, id } = params;
            const autocolons = getState().transport.autocolonItems.reduce((acc, val) => {
                acc[val.id] = val;
                return acc;
            }, {});
            if (type === 'division') {
                const { data } = yield http.put(`/division/${id}`, { name });
                dispatch(actions.setDivisionItem(data));
                if (selectedAutocolons.length) {
                    for (let autocolon of selectedAutocolons) {
                        const res = yield http.put(`/autocolon/${autocolon.id}`, Object.assign(Object.assign({}, autocolons[autocolon.id]), { name: autocolon.name, id_division: data.id }));
                        yield dispatch(actions.setAutocolonItem(res.data));
                    }
                }
                if (unselectedAutocolons.length) {
                    for (let autocolon of unselectedAutocolons) {
                        const res = yield http.put(`/autocolon/${autocolon.id}`, Object.assign(Object.assign({}, autocolons[autocolon.id]), { name: autocolon.name, id_division: null }));
                        dispatch(actions.setAutocolonItem(res.data));
                    }
                }
                return;
            }
            const { data } = yield http.put(`/autocolon/${id}`, Object.assign(Object.assign({}, autocolons[id]), { name,
                id_division }));
            return dispatch(actions.setAutocolonItem(data));
        });
    };
}
export function updateAutocolonsList(list) {
    return function transportCreateThunk() {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post(`/autocolon/list`, { list });
            yield autocolunItemsLoad();
        });
    };
}
export function deleteDivisionAutocolon(params) {
    return function transportCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, e_1, _b, _c;
            const { type, id, selectedAutocolons } = params;
            if (type === 'division') {
                yield http.delete(`/division/${id}`);
                dispatch(actions.deleteDivisionItem(id));
                if (selectedAutocolons.length) {
                    try {
                        for (var _d = true, selectedAutocolons_1 = __asyncValues(selectedAutocolons), selectedAutocolons_1_1; selectedAutocolons_1_1 = yield selectedAutocolons_1.next(), _a = selectedAutocolons_1_1.done, !_a; _d = true) {
                            _c = selectedAutocolons_1_1.value;
                            _d = false;
                            let autocolon = _c;
                            const res = yield http.put(`/autocolon/${autocolon.id}`, {
                                name: autocolon.name,
                                id_division: null,
                            });
                            dispatch(actions.setAutocolonItem(res.data));
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (!_d && !_a && (_b = selectedAutocolons_1.return)) yield _b.call(selectedAutocolons_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                return;
            }
            yield http.delete(`/autocolon/${id}`);
            return dispatch(actions.deleteAutocolonItem(id));
        });
    };
}
export function transportGroupUpdate(id, params) {
    return function transportUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/transport/group/${id}`, params);
            return dispatch(actions.updateGroupItem(data));
        });
    };
}
export function transportGroupDelete(id) {
    return function transportDeleteThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.delete(`/transport/group/${id}`);
            return dispatch(actions.deleteGroupItem(id));
        });
    };
}
export function transportItemGroupUpdate(params) {
    return function transportItemGroupUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put('/transport/items/group', params);
            return dispatch(actions.updateItems(data));
        });
    };
}
export function transportGroupTypeFormLoad() {
    return function transportGroupTypeFormLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/transport/group/type');
            return dispatch(actions.setGroupTypeItems(data));
        });
    };
}
export function transportCanGenerationLoad() {
    return function transportCanGenerationLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/transport/can/generation');
            return dispatch(actions.setCanGenerationItems(data));
        });
    };
}
export function transportGroupCheckListCreate(id, params) {
    return function transportGroupCheckListCreateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post(`/transport/group/${id}/checklist`, params);
            return dispatch(actions.addGroupSelectedItemCheckListItem(data));
        });
    };
}
export function transportGroupCheckListUpdate(id, params) {
    return function transportGroupCheckListUpdateThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.put(`/transport/group/${id}/checklist/${params.id}`, { active: params.active });
            return dispatch(actions.updateGroupSelectedItemCheckListItem(data));
        });
    };
}
export function autocolunItemsLoad() {
    return function transportGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/autocolon');
            return dispatch(actions.setAutocolonItems(data));
        });
    };
}
export function divisionItemsLoad() {
    return function transportGroupLoadThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/division');
            return dispatch(actions.setDivisionItems(data));
        });
    };
}
export default transportReducer;
